import { Events } from '../events';
import { Storage } from '@ionic/storage';
import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';

@Injectable()
export class AuthStorageService extends BaseService {

  private USER_KEY: string = 'profile';
  private ACCESS_TOKEN_KEY: string = 'access_token';
  private REFRESH_TOKEN_KEY: string = 'refresh_token';

  private _cachedAccessToken: string;

  constructor(public storage: Storage, public events: Events) {
    super();
  }

  getAccessToken(): Promise<string> {
    if(this._cachedAccessToken)
      return Promise.resolve(this._cachedAccessToken);

    return this.storage.get(this.ACCESS_TOKEN_KEY).then((token) => {
      this._cachedAccessToken = token;
      return token;
    });
  }

  getRefreshToken(): Promise<string> {
    return this.storage.get(this.REFRESH_TOKEN_KEY);
  }

  getUser(): Promise<any> {
    return this.storage.get(this.USER_KEY);
  }

  setAccessToken(value: string): Promise<void> {
    return this.storage.set(this.ACCESS_TOKEN_KEY, value).then(() =>{
      this._cachedAccessToken = value
    });
  }

  setRefreshToken(value: string): Promise<void> {
    return this.storage.set(this.REFRESH_TOKEN_KEY, value);
  }

  setUser(value:string): Promise<void> {
    return this.storage.set(this.USER_KEY, value);
  }

  removeAuthInfo(): Promise<void> {
    this._cachedAccessToken = null;

    return this.storage.remove(this.USER_KEY)
    .then(() => this.storage.remove(this.ACCESS_TOKEN_KEY))
    .then(() => this.storage.remove(this.REFRESH_TOKEN_KEY));
  }
}




// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/core/auth/auth-storage.service.ts